import { createContext } from 'react'

export const OnboardStepFormItemContext = createContext()
